// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Speech = function Speech(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M13.608 2.642H2.392a.99.99 0 00-.99.99V15.36l2.478-2.569h9.726a.99.99 0 00.99-.99V3.632a.99.99 0 00-.988-.99zM12 9.883H4V8.757h8zm0-3.208H4V5.549h8z"
    }))
  );
};

export default Speech;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Speech.js
// module id = 1053
// module chunks = 0